// These constants are used as local-storage keys.
// The reason they're stored in a separate package is because other packages
// might want to access them.
// For example, `page-package` needs these keys to clear localStorage on
// logout.

/**
 * Used primarily in class-package
 */

// Control which course is "sticky", for multi-course classes
export const LAST_OPENED_COURSE_KEY = "lastOpenedCourseInfo" as const;

// Control whether individual student scores are shown on the progress tab.
// Can be hidden, to protect anonymity when projecting this screen for the class
export const SHOW_STUDENT_SCORES_KEY =
    "showStudentScoresInProgressTab" as const;

// Const for building a map of known classCode->classDescriptor mappings. Note
// that this *may* fall out of date over time, since classCodes *can* be
// reused. So we should only rely on this mapping as an interim result while
// also looking up a canonical result from the server.
export const CLASS_CODE_TO_DESCRIPTOR_MAP_KEY =
    "classCodeToDescriptorMap" as const;

// 3 Filter options for viewing assignments:
export const DUE_DATE_RANGE_STORAGE_KEY =
    "class-package-assignments-due-date-range-storage-key" as const;
export const ASSIGNMENT_KIND_STORAGE_KEY =
    "class-package-assignment-kind-storage-key" as const;

// Save the last select date range for the overall progress report
export const OVERALL_PROGRESS_DATE_RANGE_STORAGE_KEY =
    "class-package-overall-progress-date-range-storage-key" as const;

// Save the last selected "only show my class's courses" for the overall progress report
export const OVERALL_PROGRESS_ONLY_CLASS_COURSES_STORAGE_KEY =
    "class-package-overall-progress-only-class-courses-storage-key" as const;

// Save the last selected "only show MAP content" for the overall progress report
export const OVERALL_PROGRESS_ONLY_MAP_CONTENT_STORAGE_KEY =
    "class-package-overall-progress-only-map-content-storage-key" as const;

export const KMAP_PROGRESS_DATE_RANGE_STORAGE_KEY =
    "class-package-kmap-progress-date-range-storage-key" as const;

// Default settings for new assignments, during creation
export const CONTENT_ASSIGNMENT_STORAGE_KEY =
    "content-assignments-settings_v2" as const;

export const COURSE_MASTERY_ASSIGNMENT_STORAGE_KEY =
    "course-mastery-assignments-settings" as const;

export const HIDE_K4E_COURSE_VIEW_TEACHER_DASHBOARD_STORAGE_KEY =
    "show-k4e-course-view-teacher-dashboard" as const;

// Export all of the above as a list, for easy iteration.
export const CLASS_CONSTANTS = [
    LAST_OPENED_COURSE_KEY,
    CLASS_CODE_TO_DESCRIPTOR_MAP_KEY,
    DUE_DATE_RANGE_STORAGE_KEY,
    ASSIGNMENT_KIND_STORAGE_KEY,
    OVERALL_PROGRESS_DATE_RANGE_STORAGE_KEY,
    OVERALL_PROGRESS_ONLY_CLASS_COURSES_STORAGE_KEY,
    CONTENT_ASSIGNMENT_STORAGE_KEY,
    COURSE_MASTERY_ASSIGNMENT_STORAGE_KEY,
    HIDE_K4E_COURSE_VIEW_TEACHER_DASHBOARD_STORAGE_KEY,
] as const;
